// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"cf9aa468","453":"6c084524","553":"2661f8c6"}[chunkId] + ".chunk.js";
};